import { Title } from '@mantine/core';
import React from 'react';
import { useParams } from 'react-router-dom';

import { useGetTaskQuery } from '../../../../entities/tasks/model/api/taskApi';
import { ApproveActions } from '../../../../entities/tasks/ui/ApproveActions';
import { TaskAttributes } from '../../../../entities/tasks/ui/TaskAttributes';
import { TaskHistory } from '../../../../entities/tasks/ui/TaskHistory';
import { texts } from '../../../../shared/config';
import { getErrorText } from '../../../../shared/lib';
import { TasksHistoryContent } from '../../../../shared/model/tasks/types';
import { ContentLayout } from '../../../../shared/ui/ContentLayout';
import { LinearProgress } from '../../../../shared/ui/LinearProgress';
import { Message } from '../../../../shared/ui/Message';
import styles from './Task.module.css';

interface History {
  historyList: TasksHistoryContent[];
  completedHistoryList: TasksHistoryContent[];
}

export const Task = () => {
  const { taskId } = useParams();

  const { data, error, isFetching, isError } = useGetTaskQuery(taskId!);

  const tasksHistory = React.useMemo(() => {
    const values: History = {
      historyList: [],
      completedHistoryList: [],
    };

    data?.bodyField.task_routeField.forEach((value) => {
      if (!value.actionField) {
        values.historyList.push(value);
      } else {
        values.completedHistoryList.push(value);
      }
    });

    return values;
  }, [data?.bodyField.task_routeField]);

  return (
    <ContentLayout withActions withTitle dataId="taskContent">
      {isFetching && <LinearProgress position="absolute" />}
      {data && (
        <>
          <div className={styles.title}>{data?.bodyField.task_nameField}</div>
          <TaskAttributes attributes={data.bodyField.contentField} />
          <Title data-id="attrApprovalsTitle" fw={400} mb="sm" mt="xs" order={3}>
            Лист согласования
          </Title>
          <TaskHistory dataId="attrApprovalsItem" values={tasksHistory.historyList} />
          <Title data-id="attrHistoryTitle" fw={400} mb="sm" mt="xs" order={3}>
            История изменений
          </Title>
          <TaskHistory dataId="approvalsHistoryItems" values={tasksHistory.completedHistoryList} />
          <ApproveActions values={data.bodyField.task_actionField} />
        </>
      )}
      {isError && <Message title={texts.emptyData} text={getErrorText(error)} />}
    </ContentLayout>
  );
};
